import { RemoteReorderQuestions } from 'data/usecases';
import { makeApiUrlEvaluationCriteriaQuestions } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteReorderQuestions = (): RemoteReorderQuestions => {
  return new RemoteReorderQuestions(
    makeApiUrlEvaluationCriteriaQuestions(),
    makeAxiosHttpClient(),
  );
};
